import {Pipe, PipeTransform} from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'humanizedDate',
    standalone: true
})
export class HumanizedDatePipe implements PipeTransform {

  transform(value: Date | string): string {
    if (!value) {
      return '';
    }

    return moment(value).calendar(null, {
      sameDay: '[] LT',
      nextDay: '[Tomorrow]',
      nextWeek: 'dddd',
      lastDay: '[Yesterday]',
      lastWeek: '[Last] dddd',
      sameElse: 'M/DD/YYYY'
    });
  }
}
